import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
	name: 'filter'
})
export class FilterPipe implements PipeTransform {
	transform(items: any[], searchTerm: string, labelKey?: string): any {
		if (!items || !searchTerm) {
			return items;
		}

		return items.filter((item) => {
			if (item.hasOwnProperty('StateName')) {
				return (
					item[labelKey || 'StateName'].toLowerCase().includes(searchTerm.toLowerCase()) === true ||
					item[labelKey || 'StateCode'].toLowerCase().includes(searchTerm.toLowerCase()) === true
				);
			} else if (item.hasOwnProperty('CountryName')) {
				return (
					item[labelKey || 'CountryName'].toLowerCase().includes(searchTerm.toLowerCase()) === true ||
					item[labelKey || 'CountryCode'].toLowerCase().includes(searchTerm.toLowerCase()) === true
				);
			} else if (item.hasOwnProperty('BankName')) {
				return (
					item[labelKey || 'BankName'].toLowerCase().includes(searchTerm.toLowerCase()) === true ||
					item[labelKey || 'BankCode'].toLowerCase().includes(searchTerm.toLowerCase()) === true
				);
			} else if (item.hasOwnProperty('LgaName')) {
				return (
					item[labelKey || 'LgaName'].toLowerCase().includes(searchTerm.toLowerCase()) === true ||
					item[labelKey || 'LgaCode'].toLowerCase().includes(searchTerm.toLowerCase()) === true
				);
			} else if (item.hasOwnProperty('ScholarshipTypeName')) {
				return (
					item[labelKey || 'ScholarshipTypeName'].toLowerCase().includes(searchTerm.toLowerCase()) === true
				);
			} else if (item.hasOwnProperty('ScholarshipCategoryName')) {
				return (
					item[labelKey || 'ScholarshipCategoryName'].toLowerCase().includes(searchTerm.toLowerCase()) ===
					true
				);
			} else if (item.hasOwnProperty('ScholarshipSessionName')) {
				return (
					item[labelKey || 'ScholarshipSessionName'].toLowerCase().includes(searchTerm.toLowerCase()) === true
				);
			} else if (item.hasOwnProperty('ScholarshipAwardDurationName')) {
				return (
					item[labelKey || 'ScholarshipAwardDurationName']
						.toLowerCase()
						.includes(searchTerm.toLowerCase()) === true
				);
			} else if (item.hasOwnProperty('CommunityName')) {
				return item[labelKey || 'CommunityName'].toLowerCase().includes(searchTerm.toLowerCase()) === true;
			} else if (item.hasOwnProperty('CourseOfStudyName')) {
				return item[labelKey || 'CourseOfStudyName'].toLowerCase().includes(searchTerm.toLowerCase()) === true;
			} else if (item.hasOwnProperty('GenderName')) {
				return item[labelKey || 'GenderName'].toLowerCase().includes(searchTerm.toLowerCase()) === true;
			} else if (item.hasOwnProperty('ClusterName')) {
				return item[labelKey || 'ClusterName'].toLowerCase().includes(searchTerm.toLowerCase()) === true;
			} else if (item.hasOwnProperty('ClusterCommunityName')) {
				return item[labelKey || 'ClusterCommunityName'].toLowerCase().includes(searchTerm.toLowerCase()) === true;
			} else if (item.hasOwnProperty('ProjectCategoryName')) {
				return item[labelKey || 'ProjectCategoryName'].toLowerCase().includes(searchTerm.toLowerCase()) === true;
			} else if (item.hasOwnProperty('ProjectTypeName')) {
				return item[labelKey || 'ProjectTypeName'].toLowerCase().includes(searchTerm.toLowerCase()) === true;
			} else if (item.hasOwnProperty('OilBlockName')) {
				return item[labelKey || 'OilBlockName'].toLowerCase().includes(searchTerm.toLowerCase()) === true;
			} else if (item.hasOwnProperty('OilFieldName')) {
				return item[labelKey || 'OilFieldName'].toLowerCase().includes(searchTerm.toLowerCase()) === true;
			} else if (item.hasOwnProperty('DocumentCategoryName')) {
				return item[labelKey || 'DocumentCategoryName'].toLowerCase().includes(searchTerm.toLowerCase()) === true;
			} else if (item.hasOwnProperty('DocumentSubCategoryName')) {
				return item[labelKey || 'DocumentSubCategoryName'].toLowerCase().includes(searchTerm.toLowerCase()) === true;
			}else if (item.hasOwnProperty('CorrespondenceTeamName')) {
				return item[labelKey || 'CorrespondenceTeamName'].toLowerCase().includes(searchTerm.toLowerCase()) === true;
			}else if (item.hasOwnProperty('CorrespondenceCompanyName')) {
				return item[labelKey || 'CorrespondenceCompanyName'].toLowerCase().includes(searchTerm.toLowerCase()) === true;
			}else if (item.hasOwnProperty('CorrespondenceDepartmentFunctionName')) {
				return item[labelKey || 'CorrespondenceDepartmentFunctionName'].toLowerCase().includes(searchTerm.toLowerCase()) === true;
			}
		});
	}
}
